import { QuickActionsConstants } from '../store/quickActions.constants'
import { takeLatest } from '@redux-saga/core/effects'
import { put, select } from 'redux-saga/effects'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { getUserIdSelector } from '../../user/selectors'
import {
  setAssessedBy,
  setAttempts,
  setDate,
  setMethod,
  setSuccessfulAttempt,
  setTime,
} from '../../intubation/store/intubation.actions'
import { setAddIntubationToTimeline } from '../store/quickActions.actions'
import { IUserState } from '../../user/store/user.types'
import { IIntubationOptionsState, IVitalOptionsState } from '../../options/store/options.types'
import { getIntubationOptionsSelector, getVitalOptionsSelector } from '../../options/selectors'
import { IOption } from '../../../common/common.types'

export function* setIntubationQuickAction() {
  const userId: IUserState = yield select(getUserIdSelector)
  const quickActionsObject = yield select(getQuickActionsSelector)
  const vitalsOptionsState: IVitalOptionsState = yield select(getVitalOptionsSelector)
  const { selectedQuickActionButton } = quickActionsObject
  const { props } = selectedQuickActionButton
  const { savedTimeString, currentDate, procedureAction } = props
  const { assessedByOptions } = vitalsOptionsState
  const assessedByOption = assessedByOptions.find((option) => option.id === +userId)
  const { methodOptions }: IIntubationOptionsState = yield select(getIntubationOptionsSelector)
  const methodOption = methodOptions.find((option: IOption) => option.id === procedureAction)

  yield put(setTime(savedTimeString))
  yield put(setDate(currentDate))
  yield put(setAssessedBy(assessedByOption ? assessedByOption : null))
  yield put(setSuccessfulAttempt(true))
  yield put(setAttempts('1'))
  yield put(setAddIntubationToTimeline(true))
  yield put(setMethod(methodOption ? methodOption : null))
}

export function* setIntubationQuickActionSaga() {
  yield takeLatest([QuickActionsConstants.SET_IS_INTUBATION_BUTTON_TYPE], setIntubationQuickAction)
}
